import { Smartphone, Tablet, Monitor } from 'lucide-react';
import type { DeviceType, DeviceConfig } from './types';

export const DEVICE_CONFIGS: Record<DeviceType, DeviceConfig> = {
  mobile: {
    name: 'Mobile',
    width: 375,
    height: 667,
    icon: <Smartphone size={18} />,
  },
  tablet: {
    name: 'Tablet',
    width: 768,
    height: 1024,
    icon: <Tablet size={18} />,
  },
  desktop: {
    name: 'Desktop',
    width: 1280,
    height: 800,
    icon: <Monitor size={18} />,
  },
};
